export default class TableEdges {
  static W = 'w';
  static E = 'e';
  static N = 'n';
  static S = 's';

  static getAdjacentEdge(tableEdge) {
    switch(tableEdge) {
      case TableEdges.W:
        return TableEdges.N;
      case TableEdges.E:
        return TableEdges.S;
      case TableEdges.N:
        return TableEdges.W;
      case TableEdges.S:
        return TableEdges.E;
    }
  }
}
